import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "12px !important",
    padding: "16px",
  },
  dialogTitle: {
    fontWeight: "600 !important",
    fontSize: "18px !important",
    color: "#0f172a",
    fontFamily: "'Inter', sans-serif !important",
  },
  dialogContentText: {
    color: "#64748b !important",
    fontSize: "14px !important",
    fontFamily: "'Inter', sans-serif !important",
    marginBottom: "16px !important",
  },
  cancelButton: {
    color: "#475569 !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
  },
  deleteButton: {
    color: "#ef4444 !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
  },
}));

export default useStyles;
